import { create } from 'zustand'

export interface ApresentacaoState {
  /** Overlay de apresentação aberto em tela cheia. */
  aberta: boolean
  abrir: () => void
  fechar: () => void
}

/**
 * Estado do modo apresentação global: o botão no header abre o overlay
 * (`aberta`) de qualquer tela. O catálogo de blocos e o conteúdo dos slides
 * vivem no `<ApresentacaoGlobal />`, sempre frescos — nunca em snapshot no store.
 */
export const useApresentacao = create<ApresentacaoState>((set) => ({
  aberta: false,
  abrir: () => set({ aberta: true }),
  fechar: () => set({ aberta: false }),
}))
